import { useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { jobService } from "../../../../../../services/job-service";
import { formatDate } from "../../../../admin/components/admin-ui";

function SectionBlogsSidebar() {
    const [categories, setCategories] = useState([]);
    const [recentPosts, setRecentPosts] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchInput, setSearchInput] = useState(searchParams.get("search") || "");
    const navigate = useNavigate();

    useEffect(() => {
        jobService.blogCategories().then((res) => setCategories(res.categories || [])).catch(() => {});
        jobService.blogs().then((res) => setRecentPosts((res.blogs || []).slice(0, 5))).catch(() => {});
    }, []);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        const params = new URLSearchParams(searchParams);
        if (searchInput.trim()) {
            params.set("search", searchInput.trim());
        } else {
            params.delete("search");
        }
        setSearchParams(params);
    };

    const handleCategoryClick = (catId) => {
        const params = new URLSearchParams(searchParams);
        if (catId) {
            params.set("category", catId);
        } else {
            params.delete("category");
        }
        setSearchParams(params);
    };

    const handleTagClick = (tag) => {
        const params = new URLSearchParams(searchParams);
        params.set("search", tag);
        setSearchParams(params);
        setSearchInput(tag);
    };

    return (
        <div className="side-bar">
            {/* Search Widget */}
            <div className="widget search-bx">
                <form onSubmit={handleSearchSubmit}>
                    <div className="input-group">
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Search blogs..." 
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                        <button className="btn" type="submit"><i className="feather-search" /></button>
                    </div>
                </form>
            </div>

            {/* Categories Widget */}
            <div className="widget all_services_list">
                <h4 className="section-head-small mb-4">Categories</h4>
                <div className="all_services m-b30">
                    <ul>
                        <li>
                            <button 
                                type="button" 
                                className="btn btn-link p-0 text-start text-decoration-none w-100 d-flex justify-content-between align-items-center"
                                onClick={() => handleCategoryClick(null)}
                            >
                                <span className={!searchParams.get("category") ? "fw-bold text-primary" : "text-dark"}>All Categories</span>
                            </button>
                        </li>
                        {categories.map((cat) => (
                            <li key={cat.id}>
                                <button 
                                    type="button" 
                                    className="btn btn-link p-0 text-start text-decoration-none w-100 d-flex justify-content-between align-items-center"
                                    onClick={() => handleCategoryClick(cat.id)}
                                >
                                    <span className={searchParams.get("category") === cat.id ? "fw-bold text-primary" : "text-dark"}>{cat.name}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Recent Posts Widget */}
            {recentPosts.length > 0 && (
                <div className="widget recent-posts-entry">
                    <h4 className="section-head-small mb-4">Recent Articles</h4>
                    <div className="section-content">
                        <div className="widget-post-bx">
                            {recentPosts.map((post) => (
                                <div className="widget-post clearfix" key={post.id}>
                                    <div className="wt-post-media">
                                        {post.featured_image_url ? (
                                            <img src={post.featured_image_url} alt={post.title} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }} />
                                        ) : (
                                            <div className="bg-light d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", borderRadius: "4px" }}>
                                                <i className="fa fa-image text-muted" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="wt-post-info">
                                        <div className="wt-post-header">
                                            <span className="post-date text-muted" style={{ fontSize: "11px" }}>{formatDate(post.created_at)}</span>
                                            <span className="post-title d-block fw-semibold" style={{ fontSize: "13px", lineHeight: "1.3" }}>
                                                <NavLink to={`/blog-detail/${post.id}`}>{post.title}</NavLink>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Tags Widget */}
            <div className="widget tw-sidebar-tags-wrap">
                <h4 className="section-head-small mb-4">Popular Tags</h4>
                <div className="tagcloud">
                    {["career", "jobs", "interview", "resume", "skills", "hiring", "salary", "advice"].map(tag => (
                        <button 
                            key={tag}
                            type="button"
                            className={`btn btn-sm btn-light m-1 ${searchParams.get("search") === tag ? "active btn-primary text-white" : ""}`}
                            onClick={() => handleTagClick(tag)}
                        >
                            {tag}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SectionBlogsSidebar;